/* eslint-disable no-unused-vars */
const state = {
  drawer: false,
  weekBar: false,
}

const getters = {
  getDrawerVisibility: (state) => state.drawer,
  drawerIsVisible: (state) => state.drawer,
}

const mutations = {
  SET_DRAWER(state, flag) {
    state.drawer = flag
  },
  CHANGE_DRAWER_VISIBILITY(state) {
    state.drawer = !state.drawer
  },
  SET_WEEKBAR_VISIBILITY(state, flag) {
    state.weekBar = flag
  },
}

const actions = {
  setDrawerVisibility({ commit }, value) {
    commit('SET_DRAWER', value)
  },
  changeDrawerVisibility({ commit }) {
    commit('CHANGE_DRAWER_VISIBILITY')
  },
  setWeekBarVisibility({ commit }, value) {
    commit('SET_WEEKBAR_VISIBILITY', value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
